/*
* @Author: Johnny.liu
* @Date:   2021-03-15 18:13:52
* @Last Modified by:   Johnny.liu
* @Last Modified time: 2021-03-15 18:13:52
*/
import React from 'react';
import {
	Drawer, Collapse, List, Badge, Form, Empty, Checkbox, Button, message, Col, Row,
	Input, Select, DatePicker, Space, Card, AutoComplete, Mentions, Divider, Radio, Spin,
	Tabs
} from 'antd';
import { PushpinOutlined, CalendarOutlined, PlusOutlined, CloseOutlined } from '@ant-design/icons';
import { APIService } from '../../../services/projectManager/api';
import PagePanel from './Pages/PagePanel.jsx';
import { __waterDocumentSvg } from '../../../lib/waterMarking.js';
import './InvestmentAdvisor.scss';
import 'antd/dist/antd.css';
import moment from 'moment';
import 'moment/locale/zh-cn';
import locale from 'antd/es/date-picker/locale/zh_CN';

class InvestmentAdvisor extends React.Component{

	constructor(props) {
		super(props);

		this.state = {
			isEdit: this.props.data.isEdit,
			rowId: this.props.data.rowId,
			loading: false,
			formData: {}
		};
	}

	render(){
		const { isEdit, formData, loading, rowId } = this.state;
		const { showRecord, record_id, type, flow_id, isFrom, viewMode , record , creation } = this.props.data;

		console.log(this.props.data)
		return (
			<PagePanel 
				data={{
					isEdit: isEdit, rowId: rowId, showRecord: showRecord, record_id: record_id,
					type: type, flow_id: flow_id, isFrom: isFrom, viewMode: viewMode, creation: creation
				}}
				onClose={() => this.props.data.event.closeDialog()}
				record={record}
			/>
		)
	}
}


export default InvestmentAdvisor;




// WEBPACK FOOTER //
// app/components/customPage/investment-advisor/InvestmentAdvisor.jsx